module.exports = __webpack_public_path__ + "img/favicon_conasi.3894e572.png";